import { Stack, Typography } from '@mui/material';

import { Icon, PLAN_TYPE_NAME } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { PartnerCompanyTypeChip } from '@components';
import { PLAN_TYPE_COLOR } from '@flows/private/partnerCompanies/pages/PartnerCompanyList/constants/contractTypeEnum';

import type { SelectedPartnerCompanyMobileProps } from './types';
import { EditButton } from '../../../HeaderItem/styles';

export function SelectedPartnerCompanyMobile({
  partnerCompany,
  isMainPartnerCompany,
  planType,
  onClick,
}: Readonly<SelectedPartnerCompanyMobileProps>) {
  return (
    <Stack flexDirection="row" alignItems="center" gap={1}>
      <Stack gap={1}>
        <Stack flexDirection="row" alignItems="center" gap="4px">
          <Stack gap={0.5} flexDirection="row" alignItems="center">
            <Typography variant="smallText" fontWeight={900}>
              {partnerCompany}
            </Typography>
            <PartnerCompanyTypeChip
              isMainPartnerCompany={isMainPartnerCompany}
              size="small"
            />
          </Stack>
        </Stack>
        {planType && (
          <>
            <Typography
              fontWeight={700}
              color={PLAN_TYPE_COLOR[planType]}
              variant="text"
            >
              {PLAN_TYPE_NAME[planType]}
            </Typography>
          </>
        )}
      </Stack>
      <EditButton onClick={onClick}>
        <Icon name="actions-b2b-edit" color={NEW_COLORS.PRIMARY[500]} />
      </EditButton>
    </Stack>
  );
}
